import * as React from 'react';
import { Interaction } from './LiveCam';
import { eventPropagationListener } from "../EventsPropagation/eventPropagationListener";

interface MessengerProps extends Interaction {
    timing: {
        recipient: number[];
        sender: number[];
    }
}

export default function Messenger(props: MessengerProps) {
    const { conversation, timing } = props;
    const [messages, setMessages] = React.useState<{ sender: string; text: string }[]>([]);
    const [isTyping, setIsTyping] = React.useState(false);
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const messengerRef = React.useRef<HTMLDivElement>(null);
    const [time, setTime] = React.useState(0);

    React.useEffect(() => {
        if(messengerRef.current) eventPropagationListener('videoProgress', () => setTime(prevTime => prevTime + 1));
    }, []);

    React.useEffect(() => {
        if (currentIndex >= conversation.length) return;
        const msg = conversation[currentIndex];
        // sender is typing simulation
        if(msg.sender === 'sender'){
            setIsTyping(true);
        }
        if (msg.sender === 'recipient' && timing.recipient.includes(time)) {
            setMessages(prev => [...prev, msg]);
            setCurrentIndex(prev => prev + 1);
            // sender messages appear instantly
        } else if (msg.sender === 'sender' && timing.sender.includes(time)) {
            setIsTyping(false);
            setMessages(prev => [...prev, msg]);
            setCurrentIndex(prev => prev + 1);
        }

    }, [time]);

    const getVisibleMessages = () => {
        if (messages.length <= 3) return messages;
        return messages.slice(-3);
    };

    return (
        <div className="messenger-container margin-top-1" ref={messengerRef}>
            {getVisibleMessages().map((msg, idx) => {
            const actualIndex = messages.length <= 3 ? idx : messages.length - 3 + idx;
            return (
                <div className={`message-row ${msg.sender === 'recipient' ? 'right' : 'left'}`} key={actualIndex}>
                    <div className={`bubble message-${msg.sender === 'recipient' ? 'k' : 'm'}`}>
                        {msg.text}
                    </div>
                </div>
                );
            })}
            {isTyping && (
                <div className='message-row down'>
                    <div className='bubble message-m writing'>
                        <div className='circle'></div>
                        <div className='circle'></div>
                        <div className='circle'></div>
                    </div>
                </div>
            )}
        </div>
    )
}